// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const SOCIAL_COPY = {
	discover: msg({
		message: 'Feed',
		context: 'social-discover',
		comment: 'Social discover page title and DM sidebar navigation label.',
	}),
	subtitle: msg({
		message: 'Latest posts from the community',
		context: 'social-discover',
		comment: 'Social discover page header subtitle.',
	}),
	refresh: msg({
		message: 'Refresh',
		context: 'social-discover',
		comment: 'Reload the social feed. Keep it concise.',
	}),
	emptyFeed: msg({
		message: 'No posts yet. Share something.',
		context: 'social-discover',
		comment: 'Empty social feed state.',
	}),
	feedError: msg({
		message: 'Could not load posts.',
		context: 'social-discover',
		comment: 'Social feed error state.',
	}),
	retry: msg({
		message: 'Try again',
		context: 'social-discover',
		comment: 'Retry loading the social feed.',
	}),
	composerCollapsed: msg({
		message: 'Share something with the community…',
		context: 'social-discover',
		comment: 'Collapsed social composer prompt.',
	}),
	composerNamed: msg({
		message: "What's on your mind, {name}?",
		context: 'social-discover',
		comment: 'Composer placeholder addressing the current user by display name.',
	}),
	share: msg({
		message: 'Share',
		context: 'social-discover',
		comment: 'Submit the social post. Keep it concise.',
	}),
	addImage: msg({
		message: 'Add image',
		context: 'social-discover',
		comment: 'Attach images to a social post.',
	}),
	maxImages: msg({
		message: 'Up to 4 images',
		context: 'social-discover',
		comment: 'Helper text under the social composer image action.',
	}),
	addGif: msg({
		message: 'Add GIF',
		context: 'social-discover',
		comment: 'Attach a GIF to a social post.',
	}),
	chooseGif: msg({
		message: 'Choose a GIF',
		context: 'social-discover',
		comment: 'Title of the GIF picker opened from the social composer.',
	}),
	gifError: msg({
		message: 'Could not add the GIF.',
		context: 'social-discover',
		comment: 'Error when a selected GIF cannot be attached to a social post.',
	}),
	addEmoji: msg({
		message: 'Add emoji',
		context: 'social-discover',
		comment: 'Open the emoji picker in the social composer.',
	}),
	addPoll: msg({
		message: 'Add poll',
		context: 'social-discover',
		comment: 'Attach a poll to a social post.',
	}),
	removePoll: msg({
		message: 'Remove poll',
		context: 'social-discover',
		comment: 'Remove the poll from the social composer.',
	}),
	pollQuestion: msg({
		message: 'Ask a question…',
		context: 'social-discover',
		comment: 'Composer placeholder while a poll is attached; the post text is the poll question.',
	}),
	pollOption: msg({
		message: 'Option {number}',
		context: 'social-discover',
		comment: 'Placeholder for a poll option input. Preserve {number}.',
	}),
	pollAddOption: msg({
		message: 'Add option',
		context: 'social-discover',
		comment: 'Add another option to the poll.',
	}),
	pollRemoveOption: msg({
		message: 'Remove option',
		context: 'social-discover',
		comment: 'Remove a poll option.',
	}),
	pollLength: msg({
		message: 'Poll length',
		context: 'social-discover',
		comment: 'Label for the poll duration selector.',
	}),
	pollOneDay: msg({
		message: '1 day',
		context: 'social-discover',
		comment: 'Poll duration option.',
	}),
	pollThreeDays: msg({
		message: '3 days',
		context: 'social-discover',
		comment: 'Poll duration option.',
	}),
	pollOneWeek: msg({
		message: '1 week',
		context: 'social-discover',
		comment: 'Poll duration option.',
	}),
	pollVotes: msg({
		message: '{count} votes',
		context: 'social-discover',
		comment: 'Total vote count under a poll. Preserve {count}.',
	}),
	pollDaysLeft: msg({
		message: '{count} days left',
		context: 'social-discover',
		comment: 'Time remaining on a poll. Preserve {count}.',
	}),
	pollHoursLeft: msg({
		message: '{count} hours left',
		context: 'social-discover',
		comment: 'Time remaining on a poll. Preserve {count}.',
	}),
	pollMinutesLeft: msg({
		message: '{count} minutes left',
		context: 'social-discover',
		comment: 'Time remaining on a poll. Preserve {count}.',
	}),
	pollEnded: msg({
		message: 'Final results',
		context: 'social-discover',
		comment: 'Shown under a poll that has ended.',
	}),
	pollVoteError: msg({
		message: 'Could not save your vote.',
		context: 'social-discover',
		comment: 'Error when a poll vote fails.',
	}),
	pollYourVote: msg({
		message: 'Your vote',
		context: 'social-discover',
		comment: 'Accessible label marking the option the viewer voted for.',
	}),
	showNewPosts: msg({
		message: 'Show {count} new posts',
		context: 'social-discover',
		comment: 'Pill at the top of the feed when new posts arrived. Preserve {count}.',
	}),
	showNewComments: msg({
		message: 'Show {count} new comments',
		context: 'social-discover',
		comment: 'Button above a comment thread when new comments arrived. Preserve {count}.',
	}),
	removeImage: msg({
		message: 'Remove image',
		context: 'social-discover',
		comment: 'Remove a selected composer image.',
	}),
	composerError: msg({
		message: 'Could not share this post.',
		context: 'social-discover',
		comment: 'Fallback error under the social composer.',
	}),
	like: msg({
		message: 'Like',
		context: 'social-discover',
		comment: 'Like a social post or comment. Keep it concise.',
	}),
	comments: msg({
		message: 'Comments',
		context: 'social-discover',
		comment: 'Open comments on a social post.',
	}),
	views: msg({
		message: 'Views',
		context: 'social-discover',
		comment: 'Social post view count label.',
	}),
	writeComment: msg({
		message: 'Write a comment…',
		context: 'social-discover',
		comment: 'Placeholder for the social comment composer.',
	}),
	reply: msg({
		message: 'Reply',
		context: 'social-discover',
		comment: 'Reply to a social comment. Keep it concise.',
	}),
	viewReplies: msg({
		message: '{count, plural, one {View # reply} other {View # replies}}',
		context: 'social-discover',
		comment: 'Expand hidden Facebook-style replies under a social comment. count is the number of replies.',
	}),
	hideReplies: msg({
		message: 'Hide replies',
		context: 'social-discover',
		comment: 'Collapse expanded Facebook-style replies under a social comment.',
	}),
	moreComments: msg({
		message: 'Show more comments',
		context: 'social-discover',
		comment: 'Load the next page of social comments.',
	}),
	postMenu: msg({
		message: 'Post actions',
		context: 'social-discover',
		comment: 'Open the social post overflow menu.',
	}),
	commentMenu: msg({
		message: 'Comment actions',
		context: 'social-discover',
		comment: 'Open the social comment overflow menu.',
	}),
	deletePost: msg({
		message: 'Delete post',
		context: 'social-discover',
		comment: 'Delete own social post.',
	}),
	deleteComment: msg({
		message: 'Delete comment',
		context: 'social-discover',
		comment: 'Delete own social comment.',
	}),
	deletePostTitle: msg({
		message: 'Delete this post?',
		context: 'social-discover',
		comment: 'Confirmation modal title when deleting a social post.',
	}),
	deletePostBody: msg({
		message: 'This post will be removed from Discover.',
		context: 'social-discover',
		comment: 'Confirmation modal body when deleting a social post.',
	}),
	deleteCommentTitle: msg({
		message: 'Delete this comment?',
		context: 'social-discover',
		comment: 'Confirmation modal title when deleting a social comment.',
	}),
	deleteCommentBody: msg({
		message: 'This comment will be removed from the post.',
		context: 'social-discover',
		comment: 'Confirmation modal body when deleting a social comment.',
	}),
	openImage: msg({
		message: 'Open image',
		context: 'social-discover',
		comment: 'Open social post image in lightbox.',
	}),
	legacyVideo: msg({
		message: 'Video posts are no longer supported.',
		context: 'social-discover',
		comment: 'Fallback for legacy social video posts.',
	}),
	dailyHits: msg({
		message: "Today's highlights",
		context: 'social-discover',
		comment: 'Daily highlight panel title.',
	}),
	dailyEmpty: msg({
		message: 'No highlighted post yet today.',
		context: 'social-discover',
		comment: 'Empty state for daily highlight.',
	}),
	dailyError: msg({
		message: 'Could not load the highlighted post.',
		context: 'social-discover',
		comment: 'Daily highlight error state.',
	}),
	goToPost: msg({
		message: 'Go to post',
		context: 'social-discover',
		comment: 'Jump from highlight to the post.',
	}),
	replyDeleted: msg({
		message: 'The comment being replied to is no longer available',
		context: 'social-discover',
		comment: 'Fallback when a quoted social comment was deleted.',
	}),
	dismissQuote: msg({
		message: 'Remove quote',
		context: 'social-discover',
		comment: 'Clear the quoted comment from the composer.',
	}),
	commentError: msg({
		message: 'Could not send this comment.',
		context: 'social-discover',
		comment: 'Fallback error under the social comment composer.',
	}),
	closeLightbox: msg({
		message: 'Close',
		context: 'social-discover',
		comment: 'Close the social image lightbox.',
	}),
	previousImage: msg({
		message: 'Previous image',
		context: 'social-discover',
		comment: 'Previous image in social lightbox.',
	}),
	nextImage: msg({
		message: 'Next image',
		context: 'social-discover',
		comment: 'Next image in social lightbox.',
	}),
	exploreSection: msg({
		message: 'Explore',
		context: 'social-discover',
		comment: 'Discover left navigation section for public feeds.',
	}),
	newPosts: msg({
		message: 'New posts',
		context: 'social-discover',
		comment: 'Discover feed of newly approved posts.',
	}),
	yourActivity: msg({
		message: 'Your activity',
		context: 'social-discover',
		comment: 'Discover feed of posts the user liked or commented on.',
	}),
	managementSection: msg({
		message: 'Management',
		context: 'social-discover',
		comment: 'Discover left navigation section for moderators.',
	}),
	pendingReview: msg({
		message: 'Pending review',
		context: 'social-discover',
		comment: 'Discover moderation queue of pending posts.',
	}),
	approve: msg({
		message: 'Approve',
		context: 'social-discover',
		comment: 'Approve a pending social post.',
	}),
	approvePost: msg({
		message: 'Approve post',
		context: 'social-discover',
		comment: 'Overflow menu action to approve a pending social post.',
	}),
	reject: msg({
		message: 'Reject',
		context: 'social-discover',
		comment: 'Reject a pending social post.',
	}),
	pinPost: msg({
		message: 'Pin post',
		context: 'social-discover',
		comment: 'Pin an approved social post to the top of Discover.',
	}),
	unpinPost: msg({
		message: 'Unpin post',
		context: 'social-discover',
		comment: 'Remove a social post from the pinned set.',
	}),
	adminDeletePost: msg({
		message: 'Delete post',
		context: 'social-discover',
		comment: 'Admin delete of a social post.',
	}),
	pinned: msg({
		message: 'Featured',
		context: 'social-discover',
		comment: 'Chip next to timestamp for a featured/pinned social post.',
	}),
	statusPending: msg({
		message: 'In review',
		context: 'social-discover',
		comment: 'Owner-visible pending moderation status.',
	}),
	statusApproved: msg({
		message: 'Approved',
		context: 'social-discover',
		comment: 'Owner-visible approved moderation status.',
	}),
	statusRejected: msg({
		message: 'Rejected',
		context: 'social-discover',
		comment: 'Owner-visible rejected moderation status.',
	}),
	submittedForReview: msg({
		message: 'Your post was sent for review.',
		context: 'social-discover',
		comment: 'Toast after creating a social post that enters moderation.',
	}),
	alreadyModerated: msg({
		message: 'This post was already handled by another moderator.',
		context: 'social-discover',
		comment: 'Error when a pending post was approved or rejected concurrently.',
	}),
	moderationReason: msg({
		message: 'Moderation reason',
		context: 'social-discover',
		comment: 'Label for the rejection reason picker.',
	}),
	reasonSpam: msg({
		message: 'Spam',
		context: 'social-discover',
		comment: 'Rejection reason: spam.',
	}),
	reasonInappropriate: msg({
		message: 'Inappropriate content',
		context: 'social-discover',
		comment: 'Rejection reason: inappropriate content.',
	}),
	reasonWrongCategory: msg({
		message: 'Wrong category or topic',
		context: 'social-discover',
		comment: 'Rejection reason: wrong category.',
	}),
	reasonOther: msg({
		message: 'Other',
		context: 'social-discover',
		comment: 'Rejection reason: other.',
	}),
	moderatorNote: msg({
		message: 'Internal note',
		context: 'social-discover',
		comment: 'Optional internal moderator note. Not shown to the author.',
	}),
	reviewTitle: msg({
		message: 'Review post',
		context: 'social-discover',
		comment: 'Title of the moderation review dialog.',
	}),
	emptyActivity: msg({
		message: 'Posts you like or comment on will appear here.',
		context: 'social-discover',
		comment: 'Empty activity feed.',
	}),
	emptyPending: msg({
		message: 'No posts are waiting for review.',
		context: 'social-discover',
		comment: 'Empty moderation queue.',
	}),
	pendingDenied: msg({
		message: 'You do not have permission to review posts.',
		context: 'social-discover',
		comment: 'Shown if a user opens the pending route without ACL.',
	}),
	suggestedServers: msg({
		message: 'Suggested servers',
		context: 'social-discover',
		comment: 'Feed side panel title listing discovery communities the user may want to join.',
	}),
	suggestedServersStats: msg({
		message: '{online} online · {members} members',
		context: 'social-discover',
		comment: 'Stats under a suggested server name. Preserve {online} and {members}; they are inserted by code.',
	}),
	suggestedServersJoin: msg({
		message: 'Join',
		context: 'social-discover',
		comment: 'Button that joins a suggested server from the feed side panel.',
	}),
	suggestedServersExplore: msg({
		message: 'Explore more servers',
		context: 'social-discover',
		comment: 'Link from the suggested servers panel to the server discovery page.',
	}),
} as const;
